"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_infographic__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.5 191.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f4f4f4;}.cls-3{fill:#fff;}.cls-4{fill:#4a4d4e;}.cls-5{fill:#e60000;}.cls-6{opacity:0.06;}")), /*#__PURE__*/React.createElement("title", null, "infographic-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_ic_hi-2",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pie_chart_ic_hi_2",
    "data-name": "Pie_chart_ic_hi 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96,96.09l71.24,36.28a79.81,79.81,0,0,1-14.7,20.22L96,96.09",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,96.09l56.54,56.5a79.81,79.81,0,0,0,14.7-20.22L96,96.09",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96,96.09l79.36-9.74a76,76,0,0,1-8.12,46Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96,96.09,116.65,18.9c32.46,8.69,54.58,34.12,58.67,67.45Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,96.09l56.54,56.5a79.93,79.93,0,0,1-113.08-113C60.22,18.8,88.25,11.29,116.65,18.9Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96,174.12a80,80,0,0,1-80-79c0,.34,0,.67,0,1a80,80,0,0,0,160,0c0-.33,0-.66,0-1A80,80,0,0,1,96,174.12Z",
    transform: "translate(-0.25 -0.25)"
  })))))))))))))))));
}

var _default = ic_infographic__dark;
exports.default = _default;